// extracted by mini-css-extract-plugin
export default {"moviesGrid":"MovieGrid_moviesGrid__JXyeT"};